import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var HttpResponseError = /*#__PURE__*/function (_Error) {
  _inherits(HttpResponseError, _Error);
  var _super = _createSuper(HttpResponseError);
  function HttpResponseError(resourceName, statusCode, body) {
    var _this;
    _classCallCheck(this, HttpResponseError);
    _this = _super.call(this, "Unable to fetch ".concat(resourceName, ", status: ").concat(statusCode));
    _this.name = 'HttpResponseError';
    _this.statusCode = statusCode;
    _this.body = body;

    // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
    //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(_assertThisInitialized(_this), HttpResponseError.prototype);
    return _this;
  }
  return _createClass(HttpResponseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * Throws and {@link HttpResponseError} when server returned an error
 * @param resourceName - name of the resource - used in the error message
 * @param response - the response from server to check
 */
export var rejectOnHttpError = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resourceName, response) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return response;
        case 2:
          res = _context.sent;
          if (!res.ok) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", response);
        case 5:
          _context.t0 = HttpResponseError;
          _context.t1 = resourceName;
          _context.t2 = res.status;
          _context.next = 10;
          return res.json().catch(function () {
            return undefined;
          });
        case 10:
          _context.t3 = _context.sent;
          throw new _context.t0(_context.t1, _context.t2, _context.t3);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function rejectOnHttpError(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();